// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"8fdabee0","845":"8685072a"}[chunkId] + ".chunk.js";
};